import { put, call, takeEvery } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  ADDRS_SEARCH_START,
  addrsSearchSuccess,
  addrsSearchFail,
  SUGST_ADDRS_SEARCH,
  sugstAddrsSearchSuccess,
  sugstAddrsSearchFail
} from 'portal/store/address/actions'

function getSearchAddressURI(accountId, projectId) {
  return `/accounts/${accountId}/projects/${projectId}/projectAddresses`
}

function getAddressSuggestions(accountId, projectId, moduleName, recordId) {
  return `/accounts/${accountId}/projects/${projectId}/modules/${moduleName}/records/${recordId}/knownAddressSuggestions`
}

function* searchAddressSaga(action) {
  const { accountId, projectId, searchValue } = action
  try {
    const response = yield call(() =>
      axios({
        method: 'GET',
        url: getSearchAddressURI(accountId, projectId),
        params: {
          searchAddress: searchValue
        },
        validateStatus: status => status === 200
      })
    )
    yield put(addrsSearchSuccess(response.data))
  } catch (error) {
    yield put(addrsSearchFail(error))
  }
}

function* addressSuggestionsSaga(action) {
  const { accountId, projectId, moduleName, recordId, addressType } = action
  try {
    const response = yield call(() =>
      axios({
        method: 'GET',
        url: getAddressSuggestions(accountId, projectId, moduleName, recordId),
        params: {
          addressType: addressType
        },
        validateStatus: status => status === 200
      })
    )
    yield put(sugstAddrsSearchSuccess(response.data))
  } catch (error) {
    yield put(sugstAddrsSearchFail(error))
  }
}

export function* watch() {
  yield takeEvery(ADDRS_SEARCH_START, searchAddressSaga)
  yield takeEvery(SUGST_ADDRS_SEARCH, addressSuggestionsSaga)
}
